export default __webpack_public_path__ + "src/images/aurora.svg";